import type { ReactNode } from "react";

export function headingLines(value: string | undefined): ReactNode {
  if (!value) return value;
  const parts = value.split(/\s*(?:<br\s*\/?>|\n)\s*/).filter(Boolean);
  if (parts.length < 2) return value;
  const last = parts.length - 1;
  return parts.map((part, i) => (
    <span key={i}>
      {part}
      {i < last ? " " : null}
      {i < last ? <br className="hidden lg:block" /> : null}
    </span>
  ));
}
